export default __webpack_public_path__ + "assets/commission-small.png";